import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import * as Moment from "moment";
import Tabs from "../../../components/core/tab";
import DateRangePicker from "../../../components/core/daterangepicker";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { listStaff, readStaff } from "../../../store/staff/thunkAction";
import { getListProfile } from "../../../store/profile/thunkAction";
import Dropdown from "../../../components/core/dropdown";
import { querySession } from "../../../store/session/thunkAction";
import { SessionStatus } from "../../../constant/enums";
import Table from "../../../components/core/table";
import { SessionAction } from "../../../store/session/slice";
import { goToTicket } from "../../../utils/event";
import { listGroup } from "../../../store/group/thunkAction";
import Autocomplete from "../../../components/core/autocomplete";

const RequestManage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [agents, setAgents] = useState([]);
  const [staffIds, setStaffIds] = useState([]);
  const [domain, setDomain] = useState("");
  const [startAt, setStartAt] = useState(
    Moment().subtract(6, "days").startOf("day").valueOf()
  );
  const [endAt, setEndAt] = useState(Moment().endOf("day").valueOf());
  const [isWaiting, setIsWaiting] = useState(true);
  const [currentTab, setCurrentTab] = useState(null);

  const sessionManage = useSelector((state) => state.sessionManage);
  const tokenManage = useSelector((state) => state.tokenManage);
  const staffManage = useSelector((state) => state.staffManage);
  const profileManage = useSelector((state) => state.profileManage);
  const groupManage = useSelector((state) => state.groupManage);

  const groups = _.get(groupManage, "groups", []);
  const sessions = _.get(sessionManage, "sessions");
  const staffs = _.get(staffManage, "staffs", {});
  const profiles = _.get(profileManage, "profiles");
  const hasToken = _.get(tokenManage, "hasToken");
  const staff = _.get(staffManage, "staff");
  const skip = _.get(sessionManage, "skip");
  const limit = _.get(sessionManage, "limit");
  const total = _.get(sessionManage, "total");
  const groupById = _.keyBy(groups, "_id");

  useEffect(() => {
    let filter = {
      skip,
      limit,
      domain,
      startAt,
      endAt,
      staffIds: _.map(staffIds, (staffIds) => staffIds._id),
      inStatus: isWaiting
        ? [SessionStatus.PENDING, SessionStatus.WAITING]
        : [SessionStatus.CLOSED, SessionStatus.SERVED],
    };

    if (!skip) {
      dispatch(SessionAction.clearSession());
    }

    if (hasToken) {
      dispatch(querySession(filter));
    }
  }, [
    dispatch,
    isWaiting,
    skip,
    limit,
    hasToken,
    domain,
    startAt,
    endAt,
    staffIds,
  ]);

  useEffect(() => {
    setAgents(_.values(staffs));
  }, [staffs]);

  useEffect(() => {
    if (hasToken) {
      dispatch(listStaff());
      dispatch(getListProfile());
      dispatch(readStaff());
      dispatch(listGroup());
    }
  }, [dispatch, hasToken]);

  const mapConfigAgent = {
    id: "_id",
    name: "name",
  };

  const mapConfigDomain = {
    id: "domain",
    name: "domain",
  };

  const goToSession = async (session) => {
    const sessionId = _.get(session, "_id");
    const chatId = _.get(staff, "staffId");

    navigate(`/chat/${chatId}/message/session-id/${sessionId}`);
  };

  const onChangeDateRangePicker = (dateRanger) => {
    const start = _.get(dateRanger, "start");
    const end = _.get(dateRanger, "end");

    const startOfDay = Moment(start).startOf("day").valueOf();
    const endOfDay = Moment(end).endOf("day").valueOf();

    dispatch(SessionAction.setSkip(0));
    setStartAt(startOfDay);
    setEndAt(endOfDay);
  };

  const configTable = {
    header: [
      {
        key: "no",
        label: "settings.manage.session.no",
        className: "text-center small",
        render: (row, rowIndex) => rowIndex + 1,
      },
      {
        key: "name",
        label: "settings.manage.session.requester",
        className: "small",
        render: (row) => {
          const name = _.get(row, "name");

          return name;
        },
      },
      {
        key: "ticket",
        label: "settings.manage.session.ticket",
        className: "small",
        render: (row) => {
          const ticketId = _.get(row, "ticketId");

          return ticketId ? (
            <button
              className="color-info btn-session"
              onClick={() => goToTicket(ticketId)}
            >
              <i className="fa fa-ticket-alt"></i>{" "}
              {t("settings.manage.session.view_ticket")}
            </button>
          ) : (
            "--"
          );
        },
      },
      {
        key: "domain",
        label: "settings.manage.session.domain",
        className: "small",
      },
      {
        key: "agent",
        label: "settings.manage.session.agent",
        className: "small",
        render: (row) => {
          const staffId = _.get(row, "staffId");

          return staffs[staffId]?.name || "";
        },
      },
      {
        key: "group",
        label: "settings.manage.session.group",
        className: "small",
        render: (row) => {
          const groupId = _.get(row, "groupId");

          if (groupId) {
            return groupById[groupId]?.name || "";
          }

          return "";
        },
      },
      {
        key: "requestAt",
        label: "settings.manage.session.requested_at",
        className: "small",
        render: (row) => {
          const addTime = _.get(row, "addTime");

          return addTime ? Moment(addTime).format("HH:mm - DD.MM.YYYY") : "";
        },
      },
      {
        key: "updateAt",
        label: "settings.manage.session.last_update_at",
        className: "small",
        render: (row) => {
          const updateTime = _.get(row, "updateTime");

          return updateTime
            ? Moment(updateTime).format("HH:mm - DD.MM.YYYY")
            : "";
        },
      },
      {
        key: "manage",
        label: "settings.manage.session.status",
        className: "text-center small",
        render: (row) => {
          const status = _.get(row, "status");

          return (
            <div className="d-flex gap-2" style={{ justifyContent: "center" }}>
              <div className="w-80px">
                {status === SessionStatus.PENDING && (
                  <span className="btn btn-warning btn-sm">
                    {t("session.session_status.pending")}
                  </span>
                )}
                {status === SessionStatus.WAITING && (
                  <span className="btn btn-info-light btn-sm">
                    {t("session.session_status.waiting")}
                  </span>
                )}
                {status === SessionStatus.CLOSED && (
                  <span className="btn btn-gray-light  btn-sm">
                    {t("session.session_status.closed")}
                  </span>
                )}
                {status === SessionStatus.SERVED && (
                  <span className="btn btn-success-light btn-sm">
                    {t("session.session_status.served")}
                  </span>
                )}
              </div>
            </div>
          );
        },
      },
      {
        key: "manage",
        label: "settings.manage.manage_title",
        className: "text-center small",
        render: (row) => {
          return (
            <div className="d-flex gap-2" style={{ justifyContent: "center" }}>
              <button
                className="color-dark btn-session"
                onClick={() => goToSession(row)}
                style={{ cursor: "pointer" }}
                title={t("settings.manage.session.go_to_session")}
              >
                <i className="fas fa-sign-out-alt"></i>
              </button>
            </div>
          );
        },
      },
    ],
    collection: sessions,
  };

  const onChangeTab = (tab) => {
    const id = _.get(tab, "id");

    if (!id) {
      return;
    }

    if (currentTab === id) {
      return;
    }

    setCurrentTab(id);
    dispatch(SessionAction.clearSession());
    setIsWaiting(id === "waiting_request");
  };

  return (
    <div
      className="tab-pane fade show active"
      id="requests-tab-pane"
      role="tabpanel"
      aria-labelledby="requests-tab"
      tabIndex="0"
    >
      <div className="row mb-4 g-2">
        <div className="col-lg-3">
          <DateRangePicker
            config={{
              onChange: onChangeDateRangePicker,
              startAt,
              endAt,
            }}
          />
        </div>
        <div className="col-lg-2">
          <Dropdown
            config={{
              options: profiles,
              map: mapConfigDomain,
              onSelect: (option) => {
                dispatch(SessionAction.setSkip(0));
                setDomain(_.get(option, "domain", ""));
              },
              placeholder: t("settings.manage.session.domain"),
              value: domain,
            }}
          />
        </div>
        <div className="col-lg-2">
          <Autocomplete
            config={{
              options: agents,
              map: mapConfigAgent,
              onChange: (options) => {
                dispatch(SessionAction.setSkip(0));
                setStaffIds(options);
              },
              placeholder: t("settings.manage.session.agent"),
              value: staffIds,
              isMulti: true,
            }}
          />
        </div>
      </div>
      <div className="tab-box-custom">
        <Tabs
          config={{
            onChangeTab: (tab) => onChangeTab(tab),
          }}
        >
          <div
            id="waiting_request"
            label="settings.manage.waiting_requests"
            className="btn-waiting-box show btn-waiting-requests"
          >
            <div className="table-responsive table-box mb-5">
              <Table config={configTable} />
            </div>
            <div></div>
          </div>
          <div
            id="served_request"
            label="settings.manage.served_requests"
            className="btn-waiting-box show btn-served-requests"
          >
            <div className="table-responsive table-box mb-5">
              <Table config={configTable} />
            </div>
          </div>
        </Tabs>
        {sessions.length < total && (
          <li
            className="list-group-item list-group-item-action rounded-0 border-0 text-wrap"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={() => {
                dispatch(SessionAction.setSkip(sessions.length));
              }}
            >
              Show More
            </button>
          </li>
        )}
      </div>
    </div>
  );
};

export default RequestManage;
